import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PageHero - Einheitliche Hero-Komponente für alle Seiten
 * 
 * Sorgt für konsistente Abstände, Typografie und Layout über alle Seiten hinweg
 */
const PageHero = ({ 
  label,           // Optional: Badge/Tag über der H1 (z.B. "Für Unternehmen")
  labelIcon: LabelIcon, // Optional: Icon für das Label
  title,           // Pflicht: H1-Überschrift
  subtitle,        // Pflicht: Unterzeile / Beschreibungstext
  buttonText,      // Optional: Text des primären CTA-Buttons
  buttonOnClick,   // Optional: onClick-Handler für den Button
  buttonTestId,    // Optional: test-id für den Button
  secondaryButtonText, // Optional: Text des sekundären Buttons
  secondaryButtonOnClick, // Optional: onClick-Handler für sekundären Button
  secondaryButtonTestId, // Optional: test-id für sekundären Button
  centered = true, // Standard: zentriertes Layout
  maxWidth = 'max-w-5xl', // Standard: maximale Breite des Containers
  children         // Optional: zusätzliche Inhalte unter dem Button
}) => {
  const navigate = useNavigate();

  return (
    <section className="pt-32 pb-16 px-4">
      <div className={`container ${maxWidth} mx-auto`}>
        <div className={`${centered ? 'text-center' : ''}`}>
          {/* Optionales Label/Tag */}
          {label && (
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FFF0D1] text-[#2B2142] rounded-full text-sm font-semibold mb-6">
              {LabelIcon && <LabelIcon className="w-4 h-4" />}
              {label}
            </div>
          )}

          {/* H1 - Einheitliche Typografie */}
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold mb-6 text-[#2B2142] leading-tight pb-2">
            {title}
          </h1>

          {/* Unterzeile - Einheitliche Typografie */}
          <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            {subtitle}
          </p>

          {/* Button(s) */}
          {(buttonText || secondaryButtonText) && (
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-8">
              {buttonText && (
                <button
                  onClick={buttonOnClick}
                  className="px-8 py-4 bg-[#2B2142] hover:bg-[#1E1730] text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-0.5"
                  data-testid={buttonTestId}
                >
                  {buttonText}
                </button>
              )}
              
              {secondaryButtonText && (
                <button
                  onClick={secondaryButtonOnClick}
                  className="px-8 py-4 bg-white border-2 border-[#2B2142] text-[#2B2142] hover:bg-[#F4F2F2] font-semibold rounded-xl transition-all"
                  data-testid={secondaryButtonTestId}
                >
                  {secondaryButtonText}
                </button>
              )}
            </div>
          )}

          {/* Zusätzlicher Content */}
          {children && (
            <div className="mt-8">
              {children}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
